export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-100 rounded-2xl p-8 md:p-12">
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-primary-500">
              <i className="ri-smartphone-line text-3xl md:text-4xl text-white"></i>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                随时随地，畅享高清观影
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
                快看影视全面适配手机、平板与电脑端，无论身在何处，打开浏览器即可免费观看最新电影。
                智能适配网络环境，保证流畅高清不卡顿的观影体验。无需下载安装，收藏网址即刻开始你的电影之旅。
              </p>
            </div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#hero');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.pageYOffset - 72;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="flex-shrink-0 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-movie-2-line mr-2"></i>
              立即体验
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}